module.exports = __webpack_public_path__ + "img/arrow-page.5806ddba.svg";